import { navLinks, profile } from "@/content/portfolio";
import { ThemeToggle } from "./ThemeToggle";

/**
 * Sticky page chrome, on the ink surface in both themes.
 *
 * ALIGNMENT: the gutter sits on the outer element and the band max-width on the
 * inner one, matching `Section`. The reference markup put both on the same div,
 * which insets the header content by an extra gutter once the viewport passes
 * the 1360px band — the wordmark landed 112px right of the hero's left edge at
 * 1600px and read as though it were drifting toward the centre.
 *
 * HEIGHT: the row is pinned to a fixed height so `--header-h` stays truthful;
 * every section's scroll-margin derives from it.
 */
export function Header() {
  return (
    <header className="sticky top-0 z-20 bg-surface-ink/90 backdrop-blur-[8px] border-b border-border-on-ink">
      <div className="px-gutter">
        <div className="mx-auto w-full max-w-band flex items-center justify-between gap-4 h-[56px]">
          <a href="/" className="font-display text-[22px] leading-[1] tracking-[-0.01em] text-on-ink">
            {profile.wordmark}
          </a>

          <div className="flex items-center gap-4 md:gap-6">
            <nav aria-label="Sections" className="flex gap-4 md:gap-6">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="font-label text-label-lg uppercase text-on-ink-body hover:text-signal-500 transition-colors duration-160 ease-out"
                >
                  {link.label}
                </a>
              ))}
            </nav>

            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  );
}
